import { render, staticRenderFns } from "./Statusboard.vue?vue&type=template&id=ddf3fa02&scoped=true"
import script from "./Statusboard.vue?vue&type=script&lang=js"
export * from "./Statusboard.vue?vue&type=script&lang=js"
import style0 from "./Statusboard.vue?vue&type=style&index=0&id=ddf3fa02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf3fa02",
  null
  
)

export default component.exports